import ThemedComponent from '../../hoc/ThemedComponent';
import ContractsPage from './ContractsPage';
import { default as ContractsPage3 } from '../../themes/3/pages/contracts/ContractsPage';
import { default as ContractsPage4 } from '../../themes/4/pages/contracts/ContractsPage';

const ThemedContractsPages = {
  default: ContractsPage,
  // 3: ContractsPage3,
  // 4: ContractsPage4,
};

export const ThemedContractsPage = ThemedComponent(ThemedContractsPages);
